import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {UnitsAnagrafService} from '../../../general-services/service-units-anagraf/units-anagraf.service';
import {UnitsModel} from '../../../../models/UnitsModel';
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-units-anagraf',
  templateUrl: './new-units-anagraf.component.html',
  styleUrls: ['./new-units-anagraf.component.scss']
})
export class NewUnitsAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  units: UnitsModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private unitsService: UnitsAnagrafService) {
    super();

    this.units = new UnitsModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.units.cod, [Validators.required]],
      description: [this.units.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.UNITS_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.units.cod = this.formValidator.value.cod;
      this.units.description = this.formValidator.value.description;
      this.saveSubscribe = this.unitsService.save(this.unitsService.baseUrl, this.units).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Units Cod already exists', 'Warning');
          } else {
            toastr.success('Unit was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.UNITS_ANAGRF]);
          }
        }, error => {
          toastr.error('Unit was not added', 'Error');
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
